import { render } from "./WorldIcon.vue?vue&type=template&id=27655bdc&ts=true&lang=pug"
import script from "./WorldIcon.vue?vue&type=script&lang=ts"
export * from "./WorldIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__